var map = {
	"./adidas.jpg": 5657,
	"./coca-cola.jpg": 4167,
	"./fanta.jpg": 709,
	"./ferrari.jpg": 8587,
	"./fini.jpg": 8268,
	"./ford.jpg": 5277,
	"./gucci.jpg": 4018,
	"./haribo.jpg": 5083,
	"./mercedes-benz.jpg": 6845,
	"./mms.jpg": 8397,
	"./nokia.jpg": 230,
	"./philips.jpg": 1907,
	"./porsche.jpg": 5185,
	"./ralph-lauren.jpg": 7996,
	"./siemens.jpg": 8616,
	"./sprite.jpg": 2757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3342;